import React from "react";
import "./responsive-img.scss";

const ImageWrapper = ({ loaded = false, image, children }) => (
  <div className="responsive-outer">
    <div
      className={`responsive-inner ${loaded ? "loaded" : ""}`}
      style={{
        backgroundImage: image ? `url(${image})` : ``,
      }}
    >
      {children && children}
    </div>
  </div>
);

export default ImageWrapper;
